import { createSlice } from "@reduxjs/toolkit";
import {
  createCycle,
  fetchCyclesByUser,
  fetchPredictions,
  fetchFertilityWindow,
  fetchCycleSummary,
} from "../thunks/cycleThunks";

const initialState = {
  cycles: [],
  predictions: [],
  fertilityWindow: null,
  summary: null,

  isLoading: false,
  isError: false,
  errorMessage: null,
};

const cycleSlice = createSlice({
  name: "cycle",
  initialState,
  reducers: {
    resetCycleState: () => initialState,
    clearPredictions: (state) => {
      state.predictions = [];
      state.fertilityWindow = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ✅ 1. D'abord tous les .addCase
      .addCase(createCycle.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cycles.push(action.payload);
      })
      .addCase(fetchCyclesByUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cycles = action.payload;
      })
      .addCase(fetchPredictions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.predictions = action.payload;
      })
      .addCase(fetchFertilityWindow.fulfilled, (state, action) => {
        state.isLoading = false;
        state.fertilityWindow = action.payload;
      })
      .addCase(fetchCycleSummary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.summary = action.payload;
      })
      
      // ✅ 2. Ensuite les .addMatcher (toujours après les cases)
      .addMatcher(
        (action) => action.type.startsWith("cycle/") && action.type.endsWith("/pending"),
        (state) => {
          state.isLoading = true;
          state.isError = false;
          state.errorMessage = null;
        }
      )
      .addMatcher(
        (action) => action.type.startsWith("cycle/") && action.type.endsWith("/rejected"),
        (state, action) => {
          state.isLoading = false;
          state.isError = true;
          state.errorMessage = action.payload;
        }
      );
  },
});

export const { resetCycleState, clearPredictions } = cycleSlice.actions;
export default cycleSlice.reducer;